
export const pageInitialState = (page_init) => {
  const { homeAppUrls } = page_init
  return {
    homeAppUrls,
    pageNavs: {}
  }
};

const rts = {
  handleAmmend_pageSettings: 'handleAmmend_pageSettings',
  handlePageNav: 'handlePageNav',
  handleUpdatePageDataCaption: 'handleUpdatePageDataCaption',
  syncViewItems: 'syncViewItems',
}

export const pageReducer = (state, action) => {

  switch (action.type) {
    case rts.handleAmmend_pageSettings:
      return { ...state, pageSettings: action.pageSettings, aspProps: action.aspProps }

    case rts.handleUpdatePageDataCaption:
      return { ...state, pageDataCaption: action.pageDataCaption, pageDataSubCaption: action.pageDataSubCaption }

    case rts.handlePageNav:
      const { navigationOptions, uiItemContext } = action
      const { item_state } = uiItemContext ?? {}
      const { viewItem_key } = item_state ?? {}
      const _pageNavs = state.pageNavs
      const _pageNav = {
        navOptions: navigationOptions,
        navUiItemContext: uiItemContext
      }
      if (viewItem_key) {
        _pageNavs[viewItem_key] = _pageNav
      }
      return { ...state, pageNav: _pageNav, pageNavs: _pageNavs, currentPageNav: viewItem_key }


    default:
      return { ...state }
  }
}

export const pageHandlers = (dispatch) => {
  return {
    handleAmmend_pageSettings: (pageSettings, aspProps) => dispatch({ type: rts.handleAmmend_pageSettings, pageSettings, aspProps }),
    handlePageNav: (navigationOptions, uiItemContext) => dispatch({ type: rts.handlePageNav, navigationOptions, uiItemContext }),
    handleUpdatePageDataCaption: (pageDataCaption, pageDataSubCaption) => dispatch({ type: rts.handleUpdatePageDataCaption, pageDataCaption, pageDataSubCaption }),
  }
}
